import React from "react"
export const MenuActionsWrap = ({children}) => <div className="flex" style={{position: 'absolute', top: 12, right: 60, zIndex: 9999999999}}>{children}</div>
